import { FC } from "react";
import {
  HistoryVacancySortField,
  SortOrder,
} from "../../../../store/vacancy/types";
import Sort from "../../../UI/Icons/Sort";

interface IHistoryTableHeaderProps {
  sortBy: HistoryVacancySortField;
  sortOrder: SortOrder;
  onSortChange: (field: HistoryVacancySortField) => void;
}

const HistoryTableHeader: FC<IHistoryTableHeaderProps> = ({
  sortBy,
  sortOrder,
  onSortChange,
}) => (
  <div className="bg-white py-10px px-15px d-none d-lg-flex gap-10 align-items-start align-items-lg-center justify-content-between border-bottom border-off-white fs-13 fw-400 text-black">
    <div className="flex-grow-1"></div>
    <div className="min-w-320px max-w-320px d-flex gap-20 align-items-center text-break">
      <div className="w-50px  radius-50px"></div>
      <div
        className="d-flex gap-5 align-items-center cursor-pointer"
        onClick={() => onSortChange("candidate")}
      >
        <div className="fs-13 fw-700">Candidate</div>
        <Sort active={sortBy === "candidate"} direction={sortOrder} />
      </div>
    </div>
    <div
      className="min-w-370px d-flex gap-5 align-items-center cursor-pointer"
      onClick={() => onSortChange("timeframe")}
    >
      <div className="fs-13 fw-700">Requested Timeframe</div>
      <Sort active={sortBy === "timeframe"} direction={sortOrder} />
    </div>
    <div className="min-w-165px"></div>
    <div className="min-w-24px"></div>
  </div>
);

export default HistoryTableHeader;
